import { render, staticRenderFns } from "./ResetPassToken.vue?vue&type=template&id=0ef3d874&scoped=true&"
import script from "./ResetPassToken.vue?vue&type=script&lang=js&"
export * from "./ResetPassToken.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassToken.vue?vue&type=style&index=0&id=0ef3d874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef3d874",
  null
  
)

export default component.exports